import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function TopperNotePhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="toppernote" />

    </>
  );
}

export default TopperNotePhysTopics;